import { apiRequest } from './apiClient';

function toQuery(params = {}) {
  const q = new URLSearchParams();
  Object.entries(params).forEach(([k, v]) => {
    if (v !== undefined && v !== null && v !== '') q.set(k, v);
  });
  const s = q.toString();
  return s ? `?${s}` : '';
}

// `type` is 'distributors' or 'super-stockists'.
// Returns the full envelope { success, data, pagination }.
export const fetchEnquiries = (type, params) => apiRequest(`/${type}${toQuery(params)}`);

export const fetchFilterOptions = async type =>
  (await apiRequest(`/${type}/filter-options`)).data;

export const updateEnquiryStatus = async (type, id, status) =>
  (await apiRequest(`/${type}/${id}/status`, { method: 'PATCH', body: JSON.stringify({ status }) })).data;

export const bulkUpdateStatus = (type, ids, status) =>
  apiRequest(`/${type}/bulk-status`, { method: 'PATCH', body: JSON.stringify({ ids, status }) });

export const deleteEnquiry = (type, id) =>
  apiRequest(`/${type}/${id}`, { method: 'DELETE' });

export const fetchBin = async type =>
  (await apiRequest(`/${type}/bin`)).data;

export const restoreFromBin = (type, ids) =>
  apiRequest(`/${type}/bin/restore`, { method: 'PATCH', body: JSON.stringify({ ids }) });

export const permanentlyDeleteFromBin = (type, ids) =>
  apiRequest(`/${type}/bin/permanent`, { method: 'DELETE', body: JSON.stringify({ ids }) });

// Omit `ids` for the normal filtered export; provide it to export just the
// rows the user selected in the table.
export const exportEnquiries = (type, params, format, ids = []) =>
  apiRequest(`/${type}/export${toQuery({ ...params, format, ids: ids.length ? ids.join(',') : undefined })}`);

export const importEnquiries = (type, file) => {
  const body = new FormData();
  body.append('file', file);
  return apiRequest(`/${type}/import`, { method: 'POST', body });
};

export const fetchImportTemplate = type => apiRequest(`/${type}/import-template`);
